import { getFirestore, doc, getDoc, addDoc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';
import {
  getComparisonPropertyIds,
  getStoredComparisonIds,
  saveComparisonPropertyIds,
  hasLocalCacheToMigrate,
} from '../utils/comparisonStorage';

export async function migrateLocalDataToFirestore(userId) {
  const db = getFirestore();

  const migrateFavorites = async (storageKey) => {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return;

    const favoriteIds = JSON.parse(raw);
    if (!Array.isArray(favoriteIds) || favoriteIds.length === 0) {
      localStorage.removeItem(storageKey);
      return;
    }

    const favoritesQuery = query(collection(db, 'favorites'), where('userId', '==', userId));
    const favoritesSnapshot = await getDocs(favoritesQuery);
    const existingFavoriteIds = favoritesSnapshot.docs.map((item) => item.data().propertyId);

    for (const propertyId of favoriteIds) {
      if (!existingFavoriteIds.includes(propertyId)) {
        await addDoc(collection(db, 'favorites'), {
          userId,
          propertyId,
          createdAt: new Date(),
        });
      }
    }

    localStorage.removeItem(storageKey);
  };

  try {
    await migrateFavorites('localFavorites');
  } catch (error) {
    console.error('Erro ao migrar favoritos:', error);
  }

  try {
    await migrateFavorites('localCondominiumFavorites');
  } catch (error) {
    console.error('Erro ao migrar favoritos de condomínios:', error);
  }

  try {
    const localComparison = localStorage.getItem('comparisonProperties');
    if (localComparison) {
      const comparisonItems = JSON.parse(localComparison);
      const localIds = getComparisonPropertyIds(comparisonItems);

      if (localIds.length > 0) {
        const userDoc = await getDoc(doc(db, 'users', userId));
        const existingIds = getStoredComparisonIds(userDoc.data());
        const mergedIds = [...existingIds];

        for (const propertyId of localIds) {
          if (!mergedIds.includes(propertyId)) {
            mergedIds.push(propertyId);
          }
        }

        await saveComparisonPropertyIds(
          db,
          userId,
          mergedIds.map((id) => ({ id }))
        );
      }

      localStorage.removeItem('comparisonProperties');
    }
  } catch (error) {
    console.error('Erro ao migrar comparação:', error);
  }

  try {
    const localChat = localStorage.getItem('chatMessages');
    if (localChat) {
      const chatData = JSON.parse(localChat);
      if (chatData.messages && chatData.messages.length > 0) {
        const chatsQuery = query(collection(db, 'chats'), where('userId', '==', userId));
        const chatsSnapshot = await getDocs(chatsQuery);

        if (!chatsSnapshot.empty) {
          const existingChat = chatsSnapshot.docs[0];
          await updateDoc(doc(db, 'chats', existingChat.id), {
            messages: chatData.messages.map((msg) => ({
              ...msg,
              timestamp: msg.timestamp
                ? typeof msg.timestamp === 'string'
                  ? new Date(msg.timestamp)
                  : msg.timestamp
                : new Date(),
            })),
            userName: chatData.userData?.name || '',
            userPhone: chatData.userData?.phone || '',
            userEmail: chatData.userData?.email || '',
            updatedAt: new Date(),
          });
        } else {
          await addDoc(collection(db, 'chats'), {
            messages: chatData.messages.map((msg) => ({
              ...msg,
              timestamp: msg.timestamp
                ? typeof msg.timestamp === 'string'
                  ? new Date(msg.timestamp)
                  : msg.timestamp
                : new Date(),
            })),
            userName: chatData.userData?.name || '',
            userPhone: chatData.userData?.phone || '',
            userEmail: chatData.userData?.email || '',
            userId,
            status: 'pending',
            createdAt: new Date(),
            lastMessageAt: new Date(),
            updatedAt: new Date(),
          });
        }

        localStorage.removeItem('chatMessages');
      }
    }
  } catch (error) {
    console.error('Erro ao migrar chat:', error);
  }
}

export { hasLocalCacheToMigrate };
